import { useEffect } from "react";

/**
 * Injects a <script type="application/ld+json"> tag into <head> for the
 * lifetime of the mounting component. `id` is used to identify + replace
 * the tag when routes change.
 *
 * Usage:
 *   <JsonLd id="article" data={{ "@context": "https://schema.org", ... }} />
 */
export default function JsonLd({ id, data }) {
    useEffect(() => {
        if (!id || !data) return;
        const elId = `ld-${id}`;
        let el = document.getElementById(elId);
        if (!el) {
            el = document.createElement("script");
            el.type = "application/ld+json";
            el.id = elId;
            document.head.appendChild(el);
        }
        try {
            el.textContent = JSON.stringify(data);
        } catch {
            /* noop */
        }
        return () => {
            const n = document.getElementById(elId);
            if (n) n.remove();
        };
    }, [id, data]);
    return null;
}
